import axios from 'axios';
import memoize from 'lodash/memoize';
import { setTokenAsCacheKey, memoizeWithTokenAndParams } from '../utils/memoizeUtils';
import handleDashboardWidgets from './handleDashboardWidgets';
/* istanbul ignore file */

export const fetchAllWidgets = memoize(
  () =>
    axios.post('/infrastructure/widgets/retrievePermittedWidgets', {}).then(({ data }) => data),
  setTokenAsCacheKey
);

export const fetchWorkspaceDefaults = memoizeWithTokenAndParams((workspaceCode) => {
  return axios
    .post('/infrastructure/widgets/retrieveWorkspaceWidgetDefaults', { workspaceCode })
    .then(({ data: { data } }) => data.sort((a, b) => a.rowNumber - b.rowNumber));
});

export function saveUserPreferences(key, value) {
  return axios
    .post('/infrastructure/userUIPref/save', { key, value: JSON.stringify(value) })
    .then(({ data: { data } }) => data);
}

export function fetchUserPreferences(key) {
  return axios.post('/infrastructure/userUIPref/retrieve', { key }).then(({ data }) => {
    if (key === 'DASHBOARD') return handleDashboardWidgets(data);
    return data;
  });
}

export function fetchWorkspaces() {
  // Saving DGB endpoint until BFS is set up.
  // Keeping as rpc for mocking. But converting
  // to something like REST in mock/server.js
  // const postData = {
  //   item: [
  //     {
  //       name: '',
  //       value: '',
  //     },
  //   ],
  // };
  // return axios.post('/banking-services/workspaces/getWorkspaces', postData);
  const postData = {};
  return axios.post('/workspaces', postData).then(({ data: { data } }) => data);
}

export function updateSpaces(update) {
  // Creating data in a json-server way. NOT PERMANENT
  const postData = {
    workspaces: [
      {
        workspaceId: 'dashboard',
        widgets: update
      }
    ]
  };
  // Need to send whole object back. E.g.:
  // {
  //   id: 'Home',
  //   widgets: [
  //     {
  //       widgetName: 'QUICK_TRANSFER',
  //       rowNumber: 2,
  //       columnNumber: 1
  //     },
  //     {
  //       widgetName: 'DEPOSIT_ACCOUNTS',
  //       rowNumber: 1,
  //       columnNumber: 1
  //     }
  //   ]
  // }
  return axios.post('/workspaces', postData);
}
